import { render, staticRenderFns } from "./AboutLayout.vue?vue&type=template&id=5f387f56&scoped=true"
import script from "./AboutLayout.vue?vue&type=script&lang=js"
export * from "./AboutLayout.vue?vue&type=script&lang=js"
import style0 from "./AboutLayout.vue?vue&type=style&index=0&id=5f387f56&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.25_css-loader@6.11.0_webpack@5.98.0__lodash@4._0ede07508368b0c10a5f63bb0b6a47bb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f387f56",
  null
  
)

export default component.exports